import type { AmplitudeGlobalKeys } from '@/tracking/amplitude/amplitude-properties.types';
import { removeNulls } from '@/tracking/amplitude/utils';
import type { EnrichmentPlugin, Event } from '@amplitude/analytics-types';

type AmplitudeGlobalContextSnapshot = Partial<AmplitudeGlobalKeys>;

let snapshot: AmplitudeGlobalContextSnapshot = {};

export const setAmplitudeGlobalContextSnapshot = (next: AmplitudeGlobalContextSnapshot) => {
    snapshot = next;
};

export const getAmplitudeGlobalContextSnapshot = (): AmplitudeGlobalContextSnapshot => snapshot;

// Merge just the loyalty level into the existing snapshot without replacing the rest of it.
// The loyalty level arrives asynchronously (rewards-hub shared state) after the base snapshot
// is built, so it must be merged incrementally rather than replacing the whole snapshot.
export const setAmplitudeGlobalLoyaltyLevel = (loyaltyLevel: string | null | undefined): void => {
    snapshot = {
        ...snapshot,
        'Casino Loyalty Level': loyaltyLevel ?? null
    };
};

export const mergeAmplitudeGlobalContextIntoEventProperties = (
    eventProperties: Record<string, unknown>
): Record<string, unknown> =>
    removeNulls({
        ...snapshot,
        ...eventProperties
    });

export const createCasinoEventContextEnrichmentPlugin = (): EnrichmentPlugin => {
    return {
        name: 'casino-event-context',
        type: 'enrichment',
        execute: async (event: Event) => {
            const currentEventProps = (event.event_properties ?? {}) as Record<string, unknown>;

            event.event_properties = mergeAmplitudeGlobalContextIntoEventProperties(currentEventProps);

            return event;
        }
    };
};
